import React from 'react';
import PropTypes from 'prop-types';

import { Dialog, DialogContent, DialogTitle } from '@mui/material';

import Button from '../formElements/Button';

import '../../commonStyles/muiStyles.css';
import modal from '../../commonStyles/modal.module.css';
import local from './datasets.module.css';

const DataSetsResultsModal = ({ resultRowsLength, dataSetName, onCancel, isOpen }) => {
    return (
        <Dialog open={isOpen} fullWidth={true} className="muiDialogWrapper">
            <div className={modal.modalHeader}>
                <DialogTitle>Data Set Modal - {dataSetName}</DialogTitle>
            </div>
            <DialogContent>
                <div className={`${modal.modalUploaderContent} ${local.modalResults}`}>
                    <div className={local.modalHeader}>Results</div>
                    <div className={local.modalContent}>
                        <span>Number of Entries: </span>
                        <span> {resultRowsLength} </span>
                    </div>
                </div>
                <div className={modal.actionButtons}>
                    <div className={modal.cancelButton}>
                        <Button
                            id="dataset-results-cancel-button"
                            type="button"
                            content="Close"
                            onClick={onCancel}
                        />
                    </div>
                </div>
            </DialogContent>
        </Dialog>
    );
};

DataSetsResultsModal.propTypes = {
    onCancel: PropTypes.func,
    isOpen: PropTypes.bool,
    resultRowsLength: PropTypes.number,
    dataSetName: PropTypes.string
};

export default DataSetsResultsModal;
